import { BranchService } from "./BranchService";

export type { IBranchService } from "./IBranchService";

export const branchService = new BranchService();
